import { render, staticRenderFns } from "./PdvDashboard.vue?vue&type=template&id=3fb831e2&scoped=true"
import script from "./PdvDashboard.vue?vue&type=script&lang=js"
export * from "./PdvDashboard.vue?vue&type=script&lang=js"
import style0 from "./PdvDashboard.vue?vue&type=style&index=0&id=3fb831e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb831e2",
  null
  
)

export default component.exports